import { render, staticRenderFns } from "./luckDzpLogin.vue?vue&type=template&id=7bcabe57&scoped=true&"
import script from "./luckDzpLogin.vue?vue&type=script&lang=js&"
export * from "./luckDzpLogin.vue?vue&type=script&lang=js&"
import style0 from "./luckDzpLogin.vue?vue&type=style&index=0&id=7bcabe57&prod&lang=scss&scoped=true&"
import style1 from "./luckDzpLogin.vue?vue&type=style&index=1&id=7bcabe57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcabe57",
  null
  
)

export default component.exports